export default __webpack_public_path__ + "static/media/create_subscription.4cce3f20.svg";